import { render, staticRenderFns } from "./AutoFormItem.vue?vue&type=template&id=1c6761c0"
import script from "./AutoFormItem.vue?vue&type=script&lang=js"
export * from "./AutoFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports